export enum ERROR_CODES {
  CONVERSATION_NOT_FOUND = 2000,
  MESSAGE_NOT_FOUND = 2001,
  IMAGE_NOT_FOUND = 2002,
  VIDEO_NOT_FOUND = 2003,
  DOCUMENT_NOT_FOUND = 2004,
}
